(function($) {
	'use strict';
	var iStrobe = 'iStrobe';
	var tjp = 'topazjava';
	var fa = 'FaultAnalytics';
	var iBrowser = 'ISPW iBrowser';
	var aa = 'AbendAid';

	var compuware = 'compuware';
	var abendaid = 'abendaid.jsp';
	var rotate90 = 'fa-rotate-90';
	var menuItemPrefix = 'slide-menu-item-';
	var slideMenuDisabled = 'slide-menu-disabled';
	var slideMenuCollapsed = 'slide-menu-collapsed';
	var $slideMenu = $('.slide-menu')[0] ? $('.slide-menu') : window.top.$('.slide-menu');
	var $hamburgerLine = $('.hamburger-line')[0] ? $('.hamburger-line') : window.top.$('.hamburger-line');
	var $headerToolbar = $('.header-toolbar');
	var $slideMenuButton = $('#hamburger-button-mask');
	var $slideMenuOverlay = $('#slide-menu-overlay');
	var $slideMenuItemCes = $('#slide-menu-item-ces');
	var $slideMenuItemAbendAid = $('#slide-menu-item-AbendAid');
	var $slideMenuGroupAbendAid = $slideMenuItemAbendAid.parents('.slide-menu-group');
	var header = document.getElementsByTagName('header')[0];
	if (!header) { header = window.top.document.getElementsByTagName('header')[0]; }
	var scrollPositionBeforeMenuOpened;
	
	function disableScrolling() {
		window.scrollTo(0, scrollPositionBeforeMenuOpened);
	}

	function resizeMenu() {
		// make the menu and overlay the full height of the page
		$slideMenu.height($(window).height() - $headerToolbar.outerHeight(true) + $(window).scrollTop());
		$slideMenuOverlay.height($(window).height() - $headerToolbar.outerHeight(true));
	}

	function toggleMenu() {
		$slideMenu.toggleClass('slide-menu-open');
		$hamburgerLine.toggleClass('hamburger-morphed-line');
	}
	
	function closeMenu(event) {
		var headerElementClicked = false;
		
		if (header) {
			headerElementClicked = $.contains(header, event.target);
		}
		
		if(!headerElementClicked) {
			$slideMenu.removeClass('slide-menu-open');
			$hamburgerLine.removeClass('hamburger-morphed-line');
		}
	}
	
	function scrollHandler(event) {
		closeMenu(event);
		resizeMenu();
	}

	$(document).ready(function() {
		$('.product-dependent').hide();
		$.getJSON(baseCesURL + 'registration/listApps', {
			nocache : new Date().getTime()
		})
			.done(function(appsResponse) {
				if (appsResponse.applications) {
					appsResponse.applications.forEach(function(item, index) {
						var application = item.app.replace(' ', '-');
						var $menuItem = $("li[id='" + menuItemPrefix + application + "']");
						var $menuItemLink = $menuItem.children('a');
						var $subItems = $menuItem.find('ul');

						if (application === "iStrobe") {
							$('.product-dependent.on-istrobe').show();
						}

						$menuItem.removeClass(slideMenuDisabled);
						$menuItemLink.attr('href', item.url);
						$menuItemLink.toggleClass('slide-menu-collapsed');

						// special handling for aa viewing landing page, don't want entry for each viewer
						if (application === aa) {
							$menuItem.removeClass(slideMenuDisabled);
							$menuItemLink.attr('href', '/compuware/jsp/abendaid.jsp');
							var submenuLink = '<li><a href="' + item.url + '">' + item.label + '</a></li>';
							$menuItem.find('ul').append(submenuLink);
						}

						if (item.url.split('/').length > 3
							&& location.pathname.split("/").length > 1
							&& item.url.split('/')[3] === location.pathname.split("/")[1]) {
							var $group = $menuItem.parents('.slide-menu-group');
							if (!!$group) {
								$group.parent().prepend($group);
								$menuItem.parent().prepend($menuItem);
							} else {
								$menuItem.parent().prepend($menuItem);
							}

							$subItems.removeClass(slideMenuCollapsed);
							$menuItemLink.children('i').toggleClass(rotate90);
						}
					});

					$('.slide-menu-group > ul').each(function(index, slideMenuGroup) {
						var $slideMenuGroup = $(slideMenuGroup);
						if ($slideMenuGroup.children('li:not(.slide-menu-disabled)').length < 1) {
							$slideMenuGroup.siblings('a.slide-menu-group-header').addClass('slide-menu-disabled');
						}
						;
					});

					$slideMenuItemCes.removeClass('first-slide-menu-item');
					var pathname = location.pathname.split("/");
					if (pathname[1] === compuware && pathname[3] !== abendaid) {
						$('#slide-menu-item-ces > ul').removeClass(slideMenuCollapsed);
						$($('#slide-menu-item-ces > a > i')[1]).toggleClass(rotate90);
						$slideMenuItemCes.addClass('first-slide-menu-item');
						$slideMenuItemCes.parent().prepend($slideMenuItemCes);
					} else if (pathname[1] === compuware && pathname[3] === abendaid) {
						$('#slide-menu-item-AbendAid > ul').removeClass(slideMenuCollapsed);
						$($('#slide-menu-item-AbendAid > a > i')[1]).toggleClass(rotate90);
						$slideMenuItemAbendAid.parent().prepend($slideMenuItemAbendAid);
						$slideMenuGroupAbendAid.parent().prepend($slideMenuGroupAbendAid);
					}
				}

				// this event used in various scripts, be careful with it!
				$(document).trigger('appsListed', [ appsResponse ]);

				$(document).ready(function() {
					resizeMenu();
				});

				$(window).on('resize', function() {
					resizeMenu();
				});
			});
	});
	
	$slideMenuButton.on('click', function(event) {
		toggleMenu();
	});

	$('body').on('click', function(event) {
		closeMenu(event);
	});
	
	window.onwheel = closeMenu;
	// IE compatibility
	window.onmousewheel = closeMenu;
	document.onkeydown  = closeMenu;
	window.onscroll = scrollHandler;
	
	$slideMenu.on('mouseenter', function(){
		scrollPositionBeforeMenuOpened = $(window).scrollTop();
		window.onscroll = disableScrolling;
	});
	
	$slideMenu.on('mouseleave', function(){
		window.onscroll = scrollHandler;
	});

	$('.expand-chevron').on('click', function(event, a) {
		var $current = $(event.target);
		var $currentList = $current.parent().siblings('ul');
		var clickedMenuItemId = $current.parents('li').attr('id');
		var $otherSubMenus = $('.slide-menu-collapsible:not(#' + clickedMenuItemId + ') > ul');
		$otherSubMenus.addClass('slide-menu-collapsed');
		$otherSubMenus.siblings('a').children('i').removeClass(rotate90);
		$currentList.toggleClass('slide-menu-collapsed');
		$current.toggleClass(rotate90);
		event.preventDefault();

	});
})($);